import { Component, Input } from "@angular/core";

import { NgbModal, NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "mihlolmodal",
  moduleId: module.id,
  templateUrl: "mihlolmodal.component.html",
})
export class MihlolModal {
  @Input() event: any;
  @Input() base: any;

  constructor(private modalService: NgbModal) {}

  open(content) {
    let options: NgbModalOptions = {
      windowClass: "modal-mihlol",
      backdrop: "static",
    };
    this.modalService.open(content, options);
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/mihlol/mihlolmodal.component.ts